$(document).ready(function () {
  let p = $("body").attr("p");

  if (p == "events") {
    function getProductExtraModal(
      productId,
      discountPrice = 0,
      discountPercent = 0,
      update = 0,
      productIndex = null,
      comment = "",
      productExtra = [""],
      productQuantity = 1,
      productInCart = null,
    ) {
      //Dimiss SubProductCategoryMdal
      if ($("#pos-sub-product-category-product-modal").length) {
        $("#pos-sub-product-category-product-modal").remove();
      }
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open");
      $("body").css("padding-right", "");
      //End of Dimiss SubProductCategoryMdal

      if ($("#product-extra-modal").length) {
        $("#product-extra-modal").remove();
      }

      let data = {
        location_id: locationId,
        product_id: productId,
        location_type: locationCart.location_type,
        product_extra: productExtra,
        update: update,
        comment: comment,
        discount_price: discountPrice,
        discount_percent: discountPercent,
        product_quantity: productQuantity,
        shop_type: p === "events_self_service" ? "self_service" : "pos",
        product_in_cart: productInCart,
      };
      if (productIndex !== null) {
        data.cart_index = productIndex;
      }
      if (locationCart.promo_code != "") {
        data.promo_code = locationCart.promo_code;
      }
      $.ajax({
        type: "POST",
        url: "/api/v1/private/order/get-product-extra",
        data: data,
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("body").after(data.html);
            $("#product-extra-modal").modal("show");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    const LONG_PRESS_CONFIG = {
      moveThreshold: 10,
      shortDuration: 1000,
      longDuration: 2000,
    };

    let isScrolling = false;
    let scrollTimeout;
    let lastScrollTop = 0;
    let hasScrolledDuringTouch = false;
    let isForceExtrasPopup = false;
    let isHasExtras = false;

    class LongPressHandler {
      constructor(element) {
        this.element = element;
        this.timer = null;
        this.startPos = { x: 0, y: 0 };
        this.isActive = false;
        this.isLongPressed = false;
        this.longPressLevel = null; // 'short' | 'long'
        this.pressStartTime = Date.now();
      }

      start(e) {
        if (isScrolling || hasScrolledDuringTouch) {
          return;
        }

        this.reset();
        this.isActive = true;
        this.isLongPressed = false;
        this.longPressLevel = null;
        this.pressStartTime = Date.now();
        const touch = e.type.includes("touch") ? e.originalEvent.touches[0] : e;
        this.startPos = {
          x: touch.clientX || touch.pageX,
          y: touch.clientY || touch.pageY,
        };
        this._animStartTimer = setTimeout(() => {
          if (this.isActive && !isScrolling && !hasScrolledDuringTouch) {
            this.startBorderAnimation();
          }
        }, 150);

        this.timer = setTimeout(() => {
          if (this.isActive && !isScrolling && !hasScrolledDuringTouch) {
            this.triggerLongPress();
          }
        }, LONG_PRESS_CONFIG.longDuration);
      }

      move(e) {
        if (!this.isActive || isScrolling || hasScrolledDuringTouch) return;

        const touch = e.type.includes("touch") ? e.originalEvent.touches[0] : e;
        const currentPos = {
          x: touch.clientX || touch.pageX,
          y: touch.clientY || touch.pageY,
        };

        const distance = Math.sqrt(
          Math.pow(currentPos.x - this.startPos.x, 2) +
            Math.pow(currentPos.y - this.startPos.y, 2),
        );

        if (distance > LONG_PRESS_CONFIG.moveThreshold) {
          this.cancel();
        }
      }

      end() {
        this.cancelBorderAnimation();
        if (!this.element[0].classList.contains("press-ready")) {
          this.cancelLongBorderAnimation();
        }

        if (!this.isActive || isScrolling || hasScrolledDuringTouch) {
          this.isActive = false;
          return this.isLongPressed;
        }

        const heldDuration = Date.now() - this.pressStartTime;
        this.isActive = false;

        // Already handled by the 2s timer above — do nothing
        if (this.isLongPressed) return true;

        // ← Release between 1s–2s → show extras popup
        if (
          heldDuration >= LONG_PRESS_CONFIG.shortDuration &&
          !isForceExtrasPopup &&
          isHasExtras
        ) {
          this.triggerShortPress();
        }

        return this.isLongPressed;
      }

      cancel() {
        if (this._animStartTimer) {
          clearTimeout(this._animStartTimer);
          this._animStartTimer = null;
        }

        if (!this.element[0].classList.contains("press-ready")) {
          this.cancelLongBorderAnimation();
        }

        if (this.shortTimer) {
          clearTimeout(this.shortTimer);
          this.shortTimer = null;
        }

        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.isActive = false;
        this.cancelBorderAnimation();
      }

      reset() {
        this.cancel();
        this.isLongPressed = false;
        this.longPressLevel = null;
      }

      triggerShortPress() {
        this.longPressLevel = "short";
        const productId = this.element.attr("id").split("-")[1];

        getProductExtraModal(productId);
      }

      triggerLongPress() {
        this.isLongPressed = true;
        this.isActive = false;
        this.longPressLevel = "long";

        if ($("#extras-popup").is(":visible")) {
          closeExtrasPopup();
        }
        const productId = this.element.attr("id").split("-")[1];
        this.showProductDetails(productId);
      }

      startBorderAnimation() {
        const el = this.element[0];
        // ← NEW: inject a CSS custom property animation for the border progress
        el.style.setProperty("--press-progress", "0");
        el.classList.add("press-animating");
        const duration = LONG_PRESS_CONFIG.shortDuration;
        const start = performance.now();
        this._animFrame = requestAnimationFrame(
          function tick(now) {
            const progress = Math.min((now - start) / duration, 1);
            el.style.setProperty("--press-progress", progress);
            if (progress < 1) {
              this._animFrame = requestAnimationFrame(tick.bind(this));
            } else {
              el.classList.add("press-ready");
              this.startLongBorderAnimation();
            }
          }.bind(this),
        );
      }

      cancelBorderAnimation() {
        const el = this.element[0];
        if (this._animFrame) {
          cancelAnimationFrame(this._animFrame);
          this._animFrame = null;
        }
        el.classList.remove("press-animating", "press-ready");
        el.style.removeProperty("--press-progress");
      }

      startLongBorderAnimation() {
        const el = this.element[0];
        el.style.setProperty("--press-progress-long", "0");
        el.classList.add("press-animating-long");

        const duration = LONG_PRESS_CONFIG.longDuration;
        const start = performance.now();

        this._animFrameLong = requestAnimationFrame(
          function tick(now) {
            const progress = Math.min((now - start) / duration, 1);
            el.style.setProperty("--press-progress-long", String(progress));

            if (progress < 1) {
              this._animFrameLong = requestAnimationFrame(tick.bind(this));
            }
          }.bind(this),
        );
      }

      cancelLongBorderAnimation() {
        const el = this.element[0];
        if (this._animFrameLong) {
          cancelAnimationFrame(this._animFrameLong);
          this._animFrameLong = null;
        }
        el.classList.remove("press-animating-long");
        el.style.removeProperty("--press-progress-long");
      }

      showProductDetails(productId) {
        const handler = this;
        $.ajax({
          type: "POST",
          url: "/api/v1/private/products/get-product-details",
          data: { product_id: productId },
          timeout: 10000,
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $("#content").append(data.html);
              $("#product-details-modal").modal("show");
            }
          })
          .fail(function (xhr) {
            console.error("Failed to load product details:", xhr);
            if (xhr.responseJSON?.redirect_url) {
              window.location.href = xhr.responseJSON.redirect_url;
            }
          });
      }
    }

    const longPressHandlers = new WeakMap();

    function detectScrollStart() {
      isScrolling = true;
      hasScrolledDuringTouch = true;

      // Cancel all active long press handlers when scrolling starts
      $(".shop-product-container .shop-product").each(function () {
        const handler = longPressHandlers.get(this);
        if (handler) {
          handler.cancel();
        }

        $(this).removeData("wasLongPressed lastTap");
      });
    }

    function detectScrollEnd() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 100);
    }

    $(window).on("scroll.longpress", function () {
      const currentScrollTop = $(this).scrollTop();
      if (Math.abs(currentScrollTop - lastScrollTop) > 1) {
        if (!isScrolling) {
          detectScrollStart();
        }
        lastScrollTop = currentScrollTop;
      }
      detectScrollEnd();
    });

    $(document).on(
      "scroll.longpress",
      ".shop-product-container, .product-list, [data-scroll]",
      function (e) {
        const currentScrollTop = $(this).scrollTop();
        if (Math.abs(currentScrollTop - lastScrollTop) > 1) {
          if (!isScrolling) {
            detectScrollStart();
          }
          lastScrollTop = currentScrollTop;
        }
        detectScrollEnd();
      },
    );

    let touchStartY = 0;
    let touchStartX = 0;
    let touchMoveThreshold = 2;

    $(document).on("touchstart.scroll", function (e) {
      touchStartY = e.originalEvent.touches[0].clientY;
      touchStartX = e.originalEvent.touches[0].clientX;
      hasScrolledDuringTouch = false;
    });

    $(document).on("touchmove.scroll", function (e) {
      const touchY = e.originalEvent.touches[0].clientY;
      const touchX = e.originalEvent.touches[0].clientX;
      const deltaY = Math.abs(touchY - touchStartY);
      const deltaX = Math.abs(touchX - touchStartX);

      if (deltaY > touchMoveThreshold || (deltaY > 1 && deltaY > deltaX)) {
        if (!isScrolling) {
          detectScrollStart();
        }
      }
      detectScrollEnd();
    });

    function getLongPressHandler(element) {
      const $element = $(element);
      if (!longPressHandlers.has(element)) {
        longPressHandlers.set(element, new LongPressHandler($element));
      }
      return longPressHandlers.get(element);
    }

    $(document)
      .on(
        "mousedown.longpress touchstart.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) {
            return;
          }

          if ($(this).hasClass("sub_product_category_card_btn")) {
            $(this).trigger("click.subCategory");
            return;
          }

          if (e.type === "mousedown" && e.which === 3) return;

          e.preventDefault();
          isForceExtrasPopup = $(this).data("force-extras-popup") == 1;
          isHasExtras = $(this).data("has-product-extra") == 1;
          const handler = getLongPressHandler(this);
          handler.start(e);
        },
      )

      .on(
        "mousemove.longpress touchmove.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) return;

          const handler = longPressHandlers.get(this);
          if (handler) {
            handler.move(e);
          }
        },
      )

      .on(
        "mouseup.longpress touchend.longpress",
        ".shop-product-container .shop-product",
        function (e) {
          if (isScrolling || hasScrolledDuringTouch) {
            setTimeout(() => {
              if (!isScrolling) {
                hasScrolledDuringTouch = false;
              }
            }, 100);
            return;
          }

          const handler = longPressHandlers.get(this);
          if (handler) {
            const wasLongPressed = handler.end();
            $(this).data("wasLongPressed", wasLongPressed);
          }
        },
      )

      .on(
        "mouseleave.longpress touchcancel.longpress",
        ".shop-product-container .shop-product",
        function () {
          const handler = longPressHandlers.get(this);
          if (handler) {
            handler.cancel();
          }
        },
      );

    $(document).on("hide.bs.modal", "#product-details-modal", function () {
      $(".shop-product").each(function () {
        const handler = longPressHandlers.get(this);
        if (handler) {
          handler.cancelBorderAnimation();
          handler.cancelLongBorderAnimation();
        }
      });

      $(this).remove();
      $(".modal-backdrop").remove();
    });

    const lastAnimationTime = new WeakMap();

    function triggerShadowAnimation($button) {
      const element = $button[0];
      const now = Date.now();
      const lastTime = lastAnimationTime.get(element) || 0;

      if (now - lastTime < 200) return;

      lastAnimationTime.set(element, now);

      $button.addClass("animating shadow-animate");

      setTimeout(() => {
        $button.removeClass("shadow-animate animating");
      }, 200);
    }

    $(".shop-product").each(function () {
      lastAnimationTime.set(this, 0);
    });

    $(document).on(
      "click.product touchend.product",
      ".shop-product-container .shop-product",
      function (e) {
        // Prevent clicks during or after any scroll activity
        if (isScrolling || hasScrolledDuringTouch) {
          setTimeout(() => {
            if (!isScrolling) {
              hasScrolledDuringTouch = false;
            }
          }, 100);
          return;
        }

        e.stopPropagation();
        e.preventDefault();

        const $this = $(this);

        if ($this.data("wasLongPressed")) {
          $this.removeData("wasLongPressed");
          return;
        }

        const handler = longPressHandlers.get(this);
        if (handler && handler.longPressLevel !== null) {
          handler.longPressLevel = null;
          return;
        }

        triggerShadowAnimation($this);

        const isEnableDoubleClickQuickOrder = !!$("#product-list").data(
          "enable-double-click-quick-order",
        );

        if (
          isEnableDoubleClickQuickOrder &&
          !$("#open-cart").hasClass("d-none")
        ) {
          const existingTimer = $this.data("clickTimer");
          if (existingTimer) {
            clearTimeout(existingTimer);
          }

          const now = Date.now();
          const lastTap = $this.data("lastTap") || 0;
          const tapGap = now - lastTap;

          if (tapGap < 300 && tapGap > 50) {
            $this.trigger("dblclick");
            $this.removeData("lastTap");
            return;
          } else {
            $this.data("lastTap", now);
          }
        }

        const clickTimer = setTimeout(() => {
          if (!isScrolling && !hasScrolledDuringTouch) {
            const productContainer = $this.closest(".shop-product-container");
            $(".add-product", productContainer).trigger("click");
          }
          $this.removeData("clickTimer");
        }, 200);

        $this.data("clickTimer", clickTimer);
      },
    );

    $(window).on("beforeunload", function () {
      $(".shop-product-container .shop-product").each(function () {
        const handler = longPressHandlers.get(this);
        if (handler) {
          handler.cancel();
        }

        const clickTimer = $(this).data("clickTimer");
        if (clickTimer) {
          clearTimeout(clickTimer);
        }
      });

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    });

    $(window).on("unload", function () {
      $(window).off(".longpress");
      $(document).off(".longpress .scroll");
    });

    // Disable all cancel buttons in initial Terminal Payment by default
    $(".cancel-btn")
      .css({
        cursor: "not-allowed",
        "pointer-events": "none",
      })
      .attr("disabled", false);
  }
});
